import React from 'react'
import Image from './image'
import Vedio from './vedio'
import Url from './url'
import Pdf from './Pdf'

function ItemsContentComponent({filtered,onEditContent,handleDeleteContent,addSchedule}) {
  return (
  <>{
      filtered.map((item, index) => (
                      <>
                        {item.type === "image" && (
                          <Image
                            key={index}
                            data={item}
                            addSchedule={addSchedule}
                            deleteSingleContent={handleDeleteContent}
                          />
                        )}
                        {item.type === "video" && (
                          <Vedio
                            key={index}
                            data={item}
                            addSchedule={addSchedule}
                            deleteSingleContent={handleDeleteContent}
                          />
                        )}
                        {item.type === "url" && (
                          <Url
                            key={index}
                            data={item}
                            addSchedule={addSchedule}
                            deleteSingleContent={handleDeleteContent}
                            editContent={onEditContent}
                          />
                        )}
                        {item.type === "application" && (
                          <Pdf
                            key={index}
                            data={item}
                            addSchedule={addSchedule}
                            deleteSingleContent={handleDeleteContent}
                          />
                        )}
                      </>
                    ))

  }
  </>
  )
}

export default ItemsContentComponent
